import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("header", { class: "w-full px-8 py-4" }, [
  /*#__PURE__*/_createVNode("h1", { class: "text-lg text-black font-bold" }, " みんがく | スクールAI管理ページ ")
], -1)
const _hoisted_2 = { class: "flex flex-col items-center container mx-auto" }
const _hoisted_3 = /*#__PURE__*/_createVNode("h2", { class: "text-lg text-black font-bold mb-12" }, "ご利用停止中", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("p", { class: "mb-12 text-sm text-gray-500 text-center" }, [
  /*#__PURE__*/_createTextVNode(" 現在こちらのアカウントは停止されています。"),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode(" 停止されている理由がわからない・身に覚えが無い場合は、画面左下部の「お問い合わせ」ボタンからご相談ください ")
], -1)
const _hoisted_5 = {
  key: 0,
  class: "px-6 py-8 mb-12 flex flex-col items-center bg-primary-100 rounded-md"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("p", { class: "mb-6 text-sm text-gray-500 text-center" }, [
  /*#__PURE__*/_createTextVNode(" ※ 支払に必要な有効なクレジットカードが一枚も登録されていない場合やみんがく利用料の支払に失敗した場合に、みんがくはアカウントを強制的に停止します。"),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode(" 以下の「請求・支払方法を確認」ボタンを押して、請求・支払情報を確認してください。 ")
], -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 請求・支払方法を確認 ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" ログアウト ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_m_button = _resolveComponent("m-button")

  return (_openBlock(), _createBlock("div", null, [
    _hoisted_1,
    _createVNode("main", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      (_ctx.isOwnerAndUseStripe)
        ? (_openBlock(), _createBlock("div", _hoisted_5, [
            _hoisted_6,
            _createVNode(_component_m_button, {
              color: "primary-500",
              "hover-color": "primary-600",
              "font-size": "base",
              onClick: _ctx.redirectCustomerPortal
            }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            }, 8, ["onClick"])
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_m_button, {
        color: "red-500",
        "hover-color": "red-600",
        "font-size": "base",
        outline: "",
        onClick: _ctx.signOut
      }, {
        default: _withCtx(() => [
          _hoisted_8
        ]),
        _: 1
      }, 8, ["onClick"])
    ])
  ]))
}